import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle, getTeiArticleCollections
} from '../../redux/pageAsyncActions';
import Loader from '../../components/loader';
import './styles.scss';

export const ArticleCollections: React.FunctionComponent = () => {
  const {
    article,
    collections
  } = useSelector((state: IStore) => state.article);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const {articleId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    if (articleId) {
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
      dispatch(articleAsyncActions[getTeiArticleCollections](articleId));
    }
  }, [articleId]);

  return <div className="references-page">
    {article && <header className="collections-page__header">
      <h1><FormattedMessage
        id={'gritx.article.collections'}
        defaultMessage={'collections'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="collections-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>}
    </header>}
    <main className="collections-page__container">
      {loading.includes(getTeiArticleCollections) && <Loader className="collections-page__loader"/>}
      <div className="collections-page__body">
        {collections && collections.map((c, i) => {
          return <div className="collections-page__body-line" key={i}>
            <p>{c.name}</p></div>;
        })}
      </div>
    </main>
  </div>;
};
